import { render, staticRenderFns } from "./PTree.vue?vue&type=template&id=038dea3e&"
import script from "./PTree.vue?vue&type=script&lang=js&"
export * from "./PTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports